export const getOrderItemHash = item => {
    const addonIds = item.sideDishes
        .map(addon => addon.recipe.id)
        .sort()
        .join('#')

    return `${item.recipe.id}#${addonIds}#${item.price.value}#${item.note}`
}
